import * as React from 'react';
import { BaseReactSettingsCtrlProps } from '../../controllers/BaseReactSettingsCtrl';
import { IServerAdminSettings, ISiteSettingsForServerAdmin } from '../../types/ISite';
import { SectionContainerBaseProps, SettingsFormikContainer } from './GeneralSettingsPageBase';
import { ISiteAdminSettings } from '../../types/ISiteSettingsForSiteAdmin';

/**
 * A partial list of site settings for server admin.
 * This is meant for individual section components to pick a subset of the overall settings they use
 */
export type SiteSettingsForSiteAdminProps<T extends keyof ISiteAdminSettings = keyof ISiteAdminSettings> = {
  settings: Pick<ISiteAdminSettings, T>;
  serverSettings?: IServerAdminSettings;
};

export type OuterSiteSettingsForSiteAdminProps = BaseReactSettingsCtrlProps & SectionContainerBaseProps
  & SiteSettingsForSiteAdminProps;

export function ReactSiteSettingsForSiteAdmin(props: OuterSiteSettingsForSiteAdminProps){
  return <SettingsFormikContainer {...props} />;
}
